import React from 'react';
import { SetIcon } from 'components/SetIcon';
import { PublicSetInfo } from 'store/services/sets/publicSetsApi';
import './SetCard.css';

interface SetCardProps {
  set: PublicSetInfo;
  onClick: () => void;
}

const SetCard: React.FC<SetCardProps> = ({ set, onClick }) => {
  // Format release date to "Mon YYYY"
  const formatDate = (dateStr: string | null): string => {
    if (!dateStr) return 'Unknown';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
      });
    } catch {
      return 'Unknown';
    }
  };

  // Format set type for display (e.g., "expansion" -> "Expansion")
  const formatSetType = (type: string | null): string => {
    if (!type) return '';
    return type
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className="set-card"
      onClick={onClick}
      onKeyPress={handleKeyPress}
      role="link"
      tabIndex={0}
      aria-label={`View ${set.name} cards`}
    >
      <div className="set-card-icon-container">
        <SetIcon
          setIconUrl={set.iconUrl}
          setName={set.name}
          size="lg"
          inverted={true}
        />
      </div>
      <div className="set-card-content">
        <h3 className="set-card-name">{set.name}</h3>
        <div className="set-card-meta">
          <span className="set-card-code">{set.code.toUpperCase()}</span>
          <span className="set-card-separator">|</span>
          <span className="set-card-date">{formatDate(set.releasedAt)}</span>
        </div>
        <div className="set-card-footer">
          <span className="set-card-count">{set.cardCount.toLocaleString()} cards</span>
          {set.setType && (
            <span className="set-card-type">{formatSetType(set.setType)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SetCard;
